import React, { useMemo } from 'react';
import { SubHeaderContainer, SubHeaderContent, SubHeaderMenuItem } from "./ViewComponents";
import { BodyRegular } from "../../../../atoms/fonts/Body";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { redirectTo } from '@shared/store/auth.duck';
import { useTranslation } from "react-i18next";
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';

export function MeetingRoomsSubHeader(props: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const allOffice = useSelector(selectAllOfficeEntities);
  const {t} = useTranslation();

  const isHospitalityEnabled = useMemo(() => {
    return allOffice.filter((o: OfficeEntity) => o.hospitalityEnabled).length > 0;
  }, [allOffice]);

  return (
    <SubHeaderContainer fullScreenView={props.fullScreenView}>
      <SubHeaderContent>
        <SubHeaderMenuItem selected={location.pathname === '/meeting-rooms'}
                           onClick={() => dispatch(redirectTo('/meeting-rooms'))}>
          <BodyRegular weight={600}>{t('header.meeting-rooms')}</BodyRegular>
        </SubHeaderMenuItem>
        <SubHeaderMenuItem selected={location.pathname.includes('/meeting-rooms/my-bookings')}
                           onClick={() => dispatch(redirectTo('/meeting-rooms/my-bookings'))}>
          <BodyRegular weight={600}>{t('header.view-my-bookings')}</BodyRegular>
        </SubHeaderMenuItem>
        {isHospitalityEnabled && <SubHeaderMenuItem selected={location.pathname.includes('/meeting-rooms/hospitality-orders')}
                                                    onClick={() => dispatch(redirectTo('/meeting-rooms/hospitality-orders'))}>
          <BodyRegular weight={600}>{t('header.hospitality')}</BodyRegular>
        </SubHeaderMenuItem>}
      </SubHeaderContent>
    </SubHeaderContainer>
  )
}

interface Props {
  fullScreenView?: boolean;
}
